"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartCopyRequestProcessor = exports.SmartCopyProcessor = exports.transferFutureBase = exports.SC_QUOTE = void 0;
const react_1 = require("react");
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
const trade_utils_lib_1 = require("trade_utils_lib");
exports.SC_QUOTE = "USDT";
/**
 * 转换 [base].PERP to [base]
 * @param base
 */
function transferFutureBase(base) {
    if (!base) {
        return base;
    }
    return base.split(".")[0];
}
exports.transferFutureBase = transferFutureBase;
/**
 * sc 订单参数处理
 */
const SmartCopyProcessor = (props) => {
    const { invest, investPercent, investActionType, balance, coins, signal_type, signal_param, precision, orderType, leverage, profit_stop_ratio, loss_stop_ratio, investMin, investMax, compound, profit_stop_maker, } = props;
    const parseBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(balance, precision);
    //临时方案，后续可能会有接口获取单个币种的最小投资额
    const [minInvest, minInvestDisplay, maxInvest, minInvestLoading, minInvestError] = (0, react_1.useMemo)(() => {
        return [investMin !== null && investMin !== void 0 ? investMin : "50", investMin !== null && investMin !== void 0 ? investMin : "50", investMax !== null && investMax !== void 0 ? investMax : parseBalance, false, ""];
    }, [investMax, investMin, parseBalance]);
    const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investActionType, invest, investPercent, new trade_utils_lib_1.SafeDecimal(balance).toString(), precision);
    const investState = (0, react_1.useMemo)(() => {
        const max = new trade_utils_lib_1.SafeDecimal(maxInvest).toString();
        const state = {
            state: "normal",
            min: minInvest,
            max: max,
        };
        if (parseInvest) {
            if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(parseBalance))) {
                state.state = "notEnough";
            }
            else if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(max)) {
                state.state = "large";
            }
            else if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvest))) {
                state.state = "small";
            }
        }
        return state;
    }, [maxInvest, minInvest, parseBalance, parseInvest]);
    return {
        invest: parseInvest,
        investPercent: parseInvestPercent,
        orderType: orderType,
        investState: investState,
        profit_stop_maker: !!profit_stop_maker,
        minInvestInfo: { minInvest, minInvestDisplay, maxInvest, minInvestLoading, minInvestError },
        portfolio: coins.map((a) => {
            return {
                base: a.base,
                percent: a.percent,
                signal_type: signal_type,
                signal_param: signal_param,
                profit_stop_ratio,
                loss_stop_ratio,
                leverage,
            };
        }),
        compound: !!compound,
        availableBalance: parseBalance,
    };
};
exports.SmartCopyProcessor = SmartCopyProcessor;
/**
 * sc 建单请求对象处理
 */
const SmartCopyRequestProcessor = (params, $st) => {
    return {
        type: params.orderType,
        quote: exports.SC_QUOTE,
        base: "-",
        quote_total_investment: params.invest,
        portfolio: params.portfolio,
        profit_stop_maker: !!params.profit_stop_maker,
        compound: !!params.compound,
    };
};
exports.SmartCopyRequestProcessor = SmartCopyRequestProcessor;
